import React from "react";

export function Skeleton({ width = "100%", height = 16, radius = "var(--radius-sm)", style = {} }) {
  return (
    <span style={{
      display: "block", width, height, borderRadius: radius,
      background: "var(--gradient-skeleton)", backgroundSize: "200% 100%",
      animation: "fixy-shimmer 1.6s linear infinite", ...style,
    }} />
  );
}
